import React, { useCallback, type FC } from 'react';
import Button from '@atlaskit/button';
import { Box, xcss } from '@atlaskit/primitives';
import { useActions } from '../../../../controllers/conversation-store';
import type { Option } from '../../../types';

export const OptionButton: FC<{ option: Option }> = ({ option }) => {
    const { selectOption } = useActions();

    const handleClick = useCallback(() => {
        selectOption(option);
    }, [selectOption, option]);

    return (
        <Box xcss={buttonWrapper}>
            <Button onClick={handleClick}>{option.label}</Button>
        </Box>
    );
};

const buttonWrapper = xcss({
    width: 'fit-content',
});
